export default __webpack_public_path__ + "static/media/569.5f39b2e6.png";